import React from 'react';
import HbtBreadcrumbComponent from 'Feature/V2/HbtBreadcrumb/components/HbtBreadcrumbComponent';

export interface BreadcrumbComponentProps {
  items: BreadcrumbComponentItem[];
}

export interface BreadcrumbComponentItem {
  label: string;
  href?: string;
}

export const BreadcrumbComponent = ({ items }: BreadcrumbComponentProps) => {
  const fields = {
    items: items.map((item) => ({
      fields: {
        label: {
          value: item.label
        },
        breadcrumbNavItem: {
          value: {
            href: item.href
          }
        }
      }
    }))
  };
  return <HbtBreadcrumbComponent fields={fields} />;
};
